import { inject, Injectable } from '@angular/core';
// import { AlertDialogComponent } from '../../components/alert-dialog/alert-dialog.component';
import { ConfirmationService, MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  // public dialog = inject(MatDialog);
  private messageService = inject(MessageService);
  private confirmationService = inject(ConfirmationService);

  public success(message: string): void {
    this.messageService.add({ severity: 'success', summary: 'Sukces', detail: message });
  }

  public info(message: string): void {
    this.messageService.add({ severity: 'info', summary: 'Informacja', detail: message });
  }

  public error(message: string): void {
    this.messageService.add({ severity: 'error', summary: 'Błąd', detail: message });
  }

  public warn(message: string): void {
    this.messageService.add({ severity: 'warn', summary: 'Uwaga', detail: message });
  }

  public confirmation(
    message: string,
    header: string,
    accept: () => void,
    reject: () => void = () => {
      /* no-op */
    },
  ): void {
    this.confirmationService.confirm({
      header: header,
      message: message,
      accept: accept,
      reject: reject,
    });
  }

  // public alert(
  //   message: string,
  //   title = $localize`Notice`,
  //   okCallback: () => void = () => {
  //     /* no-op */
  //   },
  // ): void {
  //   const dialogRef = this.dialog.open(AlertDialogComponent, {
  //     width: '250px',
  //     data: { message: message, title: title },
  //     disableClose: true,
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result && okCallback) {
  //       okCallback();
  //     }
  //   });
  // }
}
